import { styled } from '@mui/system'
import { Box } from '@mui/material'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const Root = styled(Box)(({ theme }) => ({
  flexWrap: 'wrap',
  display: 'flex',
  width: '100%',
  padding: '1.5rem',
}))

export const TableFilterWideInputWrapper = styled('div')(({ theme }) => ({
  margin: '1rem',
  width: 'calc(100% / 6 * 2 - 2rem)',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}))

export const TableFilterInputWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  margin: '1rem',
  width: 'calc(100% / 6 - 2rem)',
  [theme.breakpoints.down('md')]: {
    width: 'calc(50% - 2rem)',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))

export const ShowFilters = styled(Box)({
  width: '100%',
})

export const Collapse = styled(Box)({
  width: '100%',
})

export const DateIcon = styled(Box)({
  zIndex: '-1',
})

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */
